/*

  Quality Seal Portal

*/

import qualitySealPortalHelper     from "./quality-seal-portal-helper";
import qualitySealPortalValidation from "./quality-seal-portal-validation";

const qualitySealPortal = {
    wrapper: $('.c-quality-seal-portal'),

    initialize: function () {

        this.url = {
            list: this.wrapper.data('list'),
            new: this.wrapper.data('new'),
            update: this.wrapper.data('update'),
            remove: this.wrapper.data('remove'),
            download: this.wrapper.data('download'),
            species: this.wrapper.data('species'),
            contacts: this.wrapper.data('contacts')
        }

        this.validationLabels = {
            conservation: this.wrapper.data('label-validation-conservation'),
            marketing: this.wrapper.data('label-validation-marketing'),
        }

        this.popUpLabels = {
            title: this.wrapper.data('label-pop-title'),
            body: this.wrapper.data('label-pop-body'),
            linkLabel: this.wrapper.data('label-pop-link-label'),
            linkHref: this.wrapper.data('label-pop-link-href'),
        }

        this.list = this.wrapper.find('.c-quality-seal-portal__list');

        qualitySealPortalHelper.ajaxCallGet(this.url.list, 'GET')
            .done(function (data) {
                qualitySealPortal.list.html(data);
                qualitySealPortal.addEventListeners();
            })
    },

    addEventListeners: function () {

        this.addAjaxCallPostEvents()
        this.addAjaxCallForRemovingEvent()
        this.addAjaxCallForAutocompletionEvent()
        this.addButtonClickEvents()
        this.addItemAutocompletionEvent()
        this.addInputChangeEvents()
        this.addDropdownEvents()
        this.addPopUpForAnimalCategoryEvent()

        $(document).on('change', '.c-quality-seal-portal__radio', qualitySealPortalValidation.setValidation);
        $(document).on('change', '.c-quality-seal-portal__radio--conservate-1-', qualitySealPortalValidation.setValidation);
        $(document).on('change', '.c-quality-seal-portal__radio--marketing-1-', qualitySealPortalValidation.setValidation);
    },

    addAjaxCallPostEvents: function () {

        this.wrapper.find('.c-quality-seal-portal__button--download').on('click', function () {
            qualitySealPortalHelper.ajaxCallPost(qualitySealPortal.url.download, 'POST', 'html')
                .done(function (data) {
                    window.open(data, '_blank');
                });
        });

        $(document).on('submit', '.c-quality-seal-portal__form--new', function (event) {

            event.preventDefault();
            qualitySealPortal.this = $(this);
            qualitySealPortal.form = qualitySealPortal.this.closest('.c-quality-seal-portal__form');

            if (qualitySealPortalValidation.validateForm()) {
                qualitySealPortalHelper.ajaxCallPost(qualitySealPortal.url.new, 'POST', 'html', qualitySealPortal.form.serialize())
                .done(function (data) {
                    qualitySealPortal.list.html(data);
                });
            }
        });

        $(document).on('submit', '.c-quality-seal-portal__form--update', function (event) {

            event.preventDefault();
            qualitySealPortal.this = $(this);
            qualitySealPortal.form = qualitySealPortal.this.closest('.c-quality-seal-portal__form');

            if (qualitySealPortalValidation.validateForm()) {
                qualitySealPortalHelper.ajaxCallPost(qualitySealPortal.url.update, 'POST', 'html', qualitySealPortal.form.serialize())
                .done(function (data) {
                    qualitySealPortal.this.closest('.c-quality-seal-portal__section').replaceWith(data);
                });
            }
        });
    },

    addAjaxCallForRemovingEvent: function () {

        $(document).on('click', '.c-quality-seal-portal__button--remove', function () {

            if (confirm(qualitySealPortal.wrapper.data('label-remove'))) {

                qualitySealPortal.section = $(this).closest('.c-quality-seal-portal__section');

                qualitySealPortalHelper.ajaxCallPostForRemoving(qualitySealPortal.url.remove, 'POST', 'html',
                    qualitySealPortal.section.data('uid'))
                    .done(function () {
                        qualitySealPortal.section.remove();
                    });
            }
        });
    },

    addAjaxCallForAutocompletionEvent: function () {

        $(document).on('input', '.c-quality-seal-portal__input--autocomplete', function () {
            qualitySealPortal.this = $(this);
            qualitySealPortal.this.siblings('.c-quality-seal-portal__hidden').val('');
            qualitySealPortal.autocomplate = $(this).parent().find('.c-quality-seal-portal__autocomplete');
            qualitySealPortal.form = qualitySealPortal.this.closest('.c-quality-seal-portal__form');

            let autofillType = qualitySealPortal.this.closest('.c-quality-seal-portal__form').find('.c-quality-seal-portal__hidden--type').val()
            let autofillId = qualitySealPortal.this.closest('.c-quality-seal-portal__form').find('.c-quality-seal-portal__hidden--id').val()

            if (qualitySealPortal.this.data('search') === 'contacts' && autofillType !== '' && autofillId !== '') {

                qualitySealPortal.ajax = $.ajax({
                    url: qualitySealPortal.url[qualitySealPortal.this.data('search')],
                    type: 'POST',
                    dataType: 'html',
                    data: {
                        tx_psrqualitysealportal_conservationunit: {
                            keyword: this.value,
                            autofilledReference: autofillId,
                            autofilledType: autofillType,
                        }
                    },
                    success: function (data) {
                        qualitySealPortal.autocomplate.html(data);
                    },
                    beforeSend: function () {
                        if (qualitySealPortal.ajax) {
                            qualitySealPortal.ajax.abort();
                        }
                    }
                });
            } else {
                qualitySealPortal.ajax = $.ajax({
                    url: qualitySealPortal.url[qualitySealPortal.this.data('search')],
                    type: 'POST',
                    dataType: 'html',
                    data: {
                        tx_psrqualitysealportal_conservationunit: {
                            keyword: this.value
                        }
                    },
                    success: function (data) {
                        qualitySealPortal.autocomplate.html(data);
                    },
                    beforeSend: function () {
                        if (qualitySealPortal.ajax) {
                            qualitySealPortal.ajax.abort();
                        }
                    }
                });
            }
        });
    },

    addButtonClickEvents: function () {

        this.wrapper.find('.c-quality-seal-portal__button--add').on('click', function () {
            qualitySealPortal.form = qualitySealPortal.wrapper.find('.c-quality-seal-portal__form--new');

            let dataWrapper = $(qualitySealPortal.form).find('.c-quality-seal-portal__pop-up--data');

            qualitySealPortal.initalData = {
                isNewUnit: true,
                initalMarketingState: dataWrapper.data('inital-marketing-state'),
                initalConservateState: dataWrapper.data('inital-conservate-state'),
                checkedSinceLastEdit: dataWrapper.data('checked-since-lastedit'),
            }

            let validationInputs = qualitySealPortal.form.find('.c-quality-seal-portal__input--validation')
            let validationTexts  = []
            validationTexts.push(qualitySealPortal.form.find('.c-quality-seal-portal__input--validation--conservation'))
            validationTexts.push(qualitySealPortal.form.find('.c-quality-seal-portal__input--validation--marketing'))

            $(validationTexts).each(function () {
                if ($(this).html().length === 0) {
                    if ($(this).hasClass('c-quality-seal-portal__input--validation--conservation')) {
                        $(this).append(qualitySealPortal.validationLabels.conservation)
                    } else {
                        $(this).append(qualitySealPortal.validationLabels.marketing)
                    }
                }
            });
            $(validationInputs).each(function () {
                if ($(this).attr('required') === 'required' && $(this).val().trim().length >= 3) {
                    $(this).addClass('not-validated')
                } else {
                    $(this).removeClass('not-validated')
                }
            });
            qualitySealPortalValidation.setValidation($(qualitySealPortal.form).find('.c-quality-seal-portal__radio--conservate'), true)
            qualitySealPortal.form.slideToggle(300, function () {
                if ($(this).is(':visible')) {
                    qualitySealPortal.form.find('input:visible').first().focus();
                }
            });
        });

        $(document).on('click', '.c-quality-seal-portal__button--close', function () {
            $(this).closest('.c-quality-seal-portal__form').slideToggle(300);
        });

        $(document).on('click', '.c-quality-seal-portal__button--edit', function () {
            let form        = $(this).closest('.c-quality-seal-portal__section').find('.c-quality-seal-portal__form')
            let dataWrapper = $(form).find('.c-quality-seal-portal__pop-up--data');

            qualitySealPortal.initalData = {
                isNewUnit: false,
                initalMarketingState: dataWrapper.data('inital-marketing-state'),
                initalConservateState: dataWrapper.data('inital-conservate-state'),
                checkedSinceLastEdit: dataWrapper.data('checked-since-lastedit'),
            }

            qualitySealPortal.hideSource = {
                hideContactConservation: dataWrapper.data('hide-contact-conservation-override'),
            }

            qualitySealPortalValidation.setValidation($(form).find('.c-quality-seal-portal__radio--conservate'), true)
            let validationTexts = []
            validationTexts.push(form.find('.c-quality-seal-portal__input--validation--conservation'))
            validationTexts.push(form.find('.c-quality-seal-portal__input--validation--marketing'))

            qualitySealPortal.checkedSinceLastEdit = $(form).find('.data__checked-since-last-edit').html()
            let inputSourceConservation = $(form).find('.c-quality-seal-portal__input--contactConservation')[0]

            // source d-none if qualitySealPortal.checkedSinceLastEdit === 1
            if ((qualitySealPortal.checkedSinceLastEdit === '1') || (qualitySealPortal.hideSource.hideContactConservation === 1)) {
                $(inputSourceConservation).addClass('c-quality-seal-portal__input--hidden')
                //$(inputSourceConservation).removeAttr('required');
            }

            $(validationTexts).each(function () {
                if ($(this).html().length === 0) {
                    if ($(this).hasClass('c-quality-seal-portal__input--validation--conservation')) {
                        $(this).append(qualitySealPortal.validationLabels.conservation)
                    } else {
                        $(this).append(qualitySealPortal.validationLabels.marketing)
                    }
                }
            })

            $(form).slideToggle(300);
        });
    },

    addItemAutocompletionEvent: function () {

        $(document).on('click', '.c-quality-seal-portal__item--autocomplete', function () {

            qualitySealPortal.this  = $(this);
            qualitySealPortal.id    = qualitySealPortal.this.data('id');
            qualitySealPortal.type  = qualitySealPortal.this.data('type');

            qualitySealPortal.this.closest('.c-quality-seal-portal__overlay').removeClass('c-quality-seal-portal__overlay--active');
            qualitySealPortal.input = $(qualitySealPortal.this).closest('.c-quality-seal-portal__dropdown').find('.c-quality-seal-portal__input--autocomplete')
            qualitySealPortal.input.val(qualitySealPortal.this.data('title'));

            if (qualitySealPortal.id) {
                qualitySealPortal.input.siblings('.c-quality-seal-portal__hidden--id').val(qualitySealPortal.id);
            }
            if (qualitySealPortal.type) {
                qualitySealPortal.input.siblings('.c-quality-seal-portal__hidden--type').val(qualitySealPortal.type);
            }
            qualitySealPortal.checkForAnimalConservation();
            qualitySealPortalValidation.setValidation($(qualitySealPortal.form).find('.c-quality-seal-portal__radio--conservate'), true);
            qualitySealPortal.updateDropdowns();
        });
    },

    addInputChangeEvents: function () {

        $(document).on('input', '.c-quality-seal-portal__radio, .c-quality-seal-portal__checkbox, .c-quality-seal-portal__input--text', function (event) {

            qualitySealPortal.this = $(this);
            qualitySealPortal.updateDropdowns();
            qualitySealPortalValidation.setValidation($(qualitySealPortal.form).find('.c-quality-seal-portal__radio--conservate'), true);
        });

        $(document).on('input', '.c-quality-seal-portal__input--validation', function () {
            qualitySealPortalValidation.setValidation($(qualitySealPortal.form).find('.c-quality-seal-portal__radio--conservate'), true);
        });
    },

    addDropdownEvents: function () {

        $(document).on('click', '.c-quality-seal-portal__input--dropdown', function () {
            qualitySealPortal.dropdown = $(this).closest('.c-quality-seal-portal__dropdown');
            qualitySealPortal.showDropdown();
            qualitySealPortal.wrapper.find('.c-quality-seal-portal__dropdown').not(qualitySealPortal.dropdown).find('.c-quality-seal-portal__overlay').removeClass('c-quality-seal-portal__overlay--active');
        });

        $(document).click('click', function (event) {
            qualitySealPortal.dropdown = qualitySealPortal.wrapper.find('.c-quality-seal-portal__overlay--active').closest('.c-quality-seal-portal__dropdown');
            if (qualitySealPortal.dropdown && !qualitySealPortal.dropdown.has(event.target).length) {
                qualitySealPortal.dropdown.find('.c-quality-seal-portal__overlay').removeClass('c-quality-seal-portal__overlay--active');
            }
        });
    },

    showDropdown: function () {
        qualitySealPortal.dropdown.children('.c-quality-seal-portal__overlay').toggleClass('c-quality-seal-portal__overlay--active');
    },

    addPopUpForAnimalCategoryEvent: function () {

        $(document).on('click', '.c-quality-seal-portal__radio--conservate', function () {
            qualitySealPortal.checkForAnimalConservation();
        });
    },

    checkForAnimalConservation: function () {
        let isAnimalCategory = $(qualitySealPortal.form).find('.c-quality-seal-portal__hidden--type').val() === 'animalcat';
        let isConservateChecked = $(qualitySealPortal.form).find('#c-quality-seal-portal__radio--conservate-1-').prop('checked')

        if (isAnimalCategory && isConservateChecked) {
            qualitySealPortal.addPopUp();
        }
    },

    updateDropdowns: function () {

        qualitySealPortal.form = qualitySealPortal.this.closest('.c-quality-seal-portal__form');
        qualitySealPortal.overlays = qualitySealPortal.form.find('.c-quality-seal-portal__overlay');

        qualitySealPortal.overlays.each(function () {

            qualitySealPortal.label     = '';
            qualitySealPortal.overlay   = $(this);
            qualitySealPortal.inputs    = qualitySealPortal.overlay.children('.c-quality-seal-portal__group').children('.c-quality-seal-portal__radio:checked, .c-quality-seal-portal__checkbox:checked');
            qualitySealPortal.total     = qualitySealPortal.inputs.length - 1;

            qualitySealPortal.inputs.each(function (index) {

                qualitySealPortal.input = $(this);
                qualitySealPortal.label += qualitySealPortal.input.data('label');
                qualitySealPortal.more = qualitySealPortal.input.closest('.c-quality-seal-portal__group').find('.c-quality-seal-portal__more');

                if (qualitySealPortal.more.length) {
                    qualitySealPortal.value = qualitySealPortal.more.find('.c-quality-seal-portal__input--text:visible').val();
                    if (qualitySealPortal.value) {
                        qualitySealPortal.label += ' (' + qualitySealPortal.value + ')';
                    }

                    qualitySealPortal.radio = qualitySealPortal.more.find('.c-quality-seal-portal__radio:checked');
                    if (qualitySealPortal.radio.length) {
                        qualitySealPortal.value = qualitySealPortal.radio.val();
                        if (qualitySealPortal.value === 'false') {
                            qualitySealPortal.label += ' ' + qualitySealPortal.radio.data('label');
                        }
                    }
                }

                if (index !== qualitySealPortal.total) {
                    qualitySealPortal.label += ' / ';
                }
            });

            qualitySealPortal.overlay.prev('.c-quality-seal-portal__input').text(qualitySealPortal.label);
        });
    },

    addPopUp: function () {
        let popTitle        = $(document).find('.c-quality-seal-portal__pop-up--titel')[0];
        let popBody         = $(document).find('.c-quality-seal-portal__pop-up--message')[0];
        let popLinkHref     = $(document).find('.c-quality-seal-portal__pop-up--link')[0];
        let popLinkLabel    = $(document).find('.c-quality-seal-portal__pop-up--link-text')[0];
        let popText         = $(document).find('.c-quality-seal-portal__pop-up--bodytext');

        if ($(popTitle).html() === "") {
            $(popTitle).append(qualitySealPortal.popUpLabels.title);
            $(popBody).append(popText).html();
            $(popLinkLabel).append(qualitySealPortal.popUpLabels.linkLabel);
            $(popLinkHref).attr('href', qualitySealPortal.popUpLabels.linkHref)
        }

        let popUpWrapper        = $(document).find('.c-quality-seal-portal__pop-up--wrapper').css('display', 'block');
        let conservateRadioYes  = $(qualitySealPortal.form).find('#c-quality-seal-portal__radio--conservate-1-');
        let conservateRadioNo   = $(qualitySealPortal.form).find('#c-quality-seal-portal__radio--conservate-0-');

        $(conservateRadioYes).prop('checked', false);
        $(conservateRadioNo).prop('checked', true);
        qualitySealPortal.updateDropdowns();

        $(document).on('click', '.c-quality-seal-portal__pop-up--link, .c-quality-seal-portal__pop-up--close', function () {
            $(popUpWrapper).css('display', 'none');
            $(conservateRadioYes).prop('checked', false);
            $(conservateRadioNo).prop('checked', true);
            qualitySealPortal.updateDropdowns();
        });
    },
};

if (qualitySealPortal.wrapper.length) {
    qualitySealPortal.initialize();
}

export default qualitySealPortal
